const { Heading } = require('@chakra-ui/react');

const Pending = () => {
  return <Heading p="10vh">Pending</Heading>;
};

export default Pending;
